import Api from "@/services/Index";

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/tuition-assistance-re-evaluations", config);
};

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/tuition-assistance-re-evaluations/" + id);
};

const store = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;

    let config={
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }

    return Api.post("/tuition-assistance-re-evaluations", formData, config);
};

const preEvaluate = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post(`/tuition-assistance-re-evaluations/${id}/pre-evaluate`, formData);
};
const approve = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post(`/tuition-assistance-re-evaluations/${id}/approve`, formData);
};

const getInstructorCoursesAndStudents = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/tuition-assistance-re-evaluations/instructor-courses-and-students', data);
}
const getGradeChangeForm  = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/tuition-assistance-re-evaluations/form', data);
}
const download = async (uuid) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/tuition-assistance-re-evaluations/download/' + uuid, {responseType: "arraybuffer"});
}

export default {
    getAll,
    get,
    getGradeChangeForm,
    getInstructorCoursesAndStudents,
    store,
    preEvaluate,
    approve,
    download
};
